import { GridItem } from '@calendly/ui/components/grid';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { usePresetFilterSheetLayout } from '../preset_filter_sheet_layout_context';
import { presetFilterFieldItemCss, presetFilterSectionContentCss, presetFilterSectionHeaderCss } from '../preset_filter_sheet_styles';
const sectionLabelItemCss = "sjzg2qu";
const sectionContentCss = "s1kq612q";
const sectionContentItemCss = "sbfnfp7";

/**
 * Section heading for the preset meetings filter sheet (Source, Filters, etc.).
 * Set wrapContent when children are not grid items (e.g. scope + view switcher stack).
 */
export const FilterSectionGroup = ({
  label,
  children,
  wrapContent = false,
  contentClassName,
  contentTestId,
  headerClassName
}) => {
  const presetSheet = usePresetFilterSheetLayout();
  if (presetSheet) {
    return <>
        <GridItem size="12" className={presetFilterFieldItemCss}>
          <div className={classNames(presetFilterSectionHeaderCss, headerClassName)}>
            <LabelText size="large" weight="bold" color={colorTextSecondary}>
              {label}
            </LabelText>
          </div>
        </GridItem>
        {wrapContent ? <GridItem size="12" className={presetFilterFieldItemCss}>
            <div className={classNames(contentClassName ?? presetFilterSectionContentCss)} data-testid={contentTestId}>
              {children}
            </div>
          </GridItem> : children}
      </>;
  }
  return <>
      <GridItem size="12" className={sectionLabelItemCss}>
        <BodyText weight="bold">{label}</BodyText>
      </GridItem>
      {wrapContent ? <GridItem size="12" className={sectionContentItemCss}>
          <div className={sectionContentCss}>{children}</div>
        </GridItem> : children}
    </>;
};

require("./filter_section_group.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_section_group.js");